/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionsDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import PatientCommsOverlay from 'DesignSystem/PatientComms/PatientCommsOverlay/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ActionsDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/ActionsDialog",
  contentRef,
  left,
  top,
  onMouseEnter,
  update
  
}) {
let eventSelectedShowactionsdialogValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'selected.showActionsDialog',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={eventSelectedShowactionsdialogValueData}>
<div
  data-testid="ActionsDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 onMouseEnter={onMouseEnter}
 style={{'--l-1-1P9YCu': typeof left === 'number' ? `${left}px` : left,'--t-2-1P9YCu': typeof top === 'number' ? `${top}px` : top,'--btlr-3-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-8-1P9YCu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-9-1P9YCu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-10-1P9YCu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-11-1P9YCu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-12-1P9YCu': dtColorsWhite,'--bc-13-1P9YCu': dtColorsNeutral100}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Content
  viewPath={`${viewPath}/Content`}
 update={update}
/>
</div>
</fromFlow.When>
)}
</FloatingPortal>
<PatientCommsOverlay
  viewPath={`${viewPath}/PatientCommsOverlay`}
/>
{children}
</React.Fragment>)
}